import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Card } from "antd";
import { If, Else, Then } from "react-if";
import { useHistory } from "react-router-dom";

import Sound from "../../utilities/sound";
import CommonService from "../../service/CommonService";
import loginService from "../../service/login";
import { setPopup } from "../../actions/popupAction";
import { downloadPatientFilesSagaAction } from "../../sagas/saga-fileDownload";
import { checkUrl, NEXTGEN_EHR_WHITELABEL } from "../../constants/constants";
import Layout from "../../components/layout";
import Sidenav from "./components/sidenav/sidenav";
import Chat from "./components/chat/chat";
import CustomNotification from "../../components/notification";
import welcomeChatIcon from "../../images/chat/welcome.png";
import { LiveAgentLogo, nextgenWelcomeIcon } from "../../assets/svg";
import MobileMenu from "../../components/mobileMenu";
import MobileHeader from "../../components/header/mobileHeader";

const LiveAgent = (props) => {
  const commonService = new CommonService();
  const history = useHistory();
  const [state, setState] = useState({
    showChat: false,
    showDetails: false,
    activeChatPatientNumber: "",
    notConfigured: true,
  });

  const handleAgentChat = (value) => {
    setState((st) => ({
      ...st,
      showChat: value,
    }));
  };

  const _showAgentChat = () => {
    handleAgentChat(true);
  };

  const _hideAgentChat = () => {
    handleAgentChat(false);
  };

  const handleShowDetails = () => {
    setState((st) => ({ ...st, showDetails: !st.showDetails }));
  };

  const getActivePatientNumber = (cellPhone) => {
    setState((st) => ({ ...st, activeChatPatientNumber: cellPhone }));
  };

  const checkConfiguration = async () => {
    const checkAgentConfigurationExists = await commonService.fetchAppointmentData();
    if (!checkAgentConfigurationExists) {
      setState((st) => ({
        ...st,
        notConfigured: false,
        clickedSearch: false,
      }));
    }

    const user =
      loginService.getDecodedToken() &&
      loginService.getDecodedToken().payload &&
      loginService.getDecodedToken().payload;

    if (!user.liveAgentAccess) {
      checkUrl(user, history);
    }
  };

  useEffect(() => {
    const {
      liveAgentAccess,
      liveChatAccess,
      broadcastAccess,
    } = loginService.getUser();
    if (!liveAgentAccess) {
      if (liveChatAccess) {
        history.push("/chat");
      } else if (broadcastAccess) {
        history.push("/broadcast");
      } else {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `You do not have access!`,
        });
        loginService.Logout();
        history.push("/");
      }
    } else {
      checkConfiguration();

      window.addEventListener("showChat", _showAgentChat, false);
      window.addEventListener("hideChat", _hideAgentChat, false);

      return () => {
        window.removeEventListener("showChat", _showAgentChat);
        window.removeEventListener("hideChat", _hideAgentChat);
      };
    }
  }, []);

  const { customPopupMessage, messageType, message } = props.popupReducer;

  return (
    <Layout testId="live-agent-main-page-wrapper">
      <div className="display-in-mob">
        <MobileHeader
          showLogo={true}
          showNotifications={true}
          showHelp={false}
          showAccountDetails={true}
          backgroundColor="black-bg"
        />
      </div>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}

      <div className="inner-content-wrapper">
        <Card
          className="primary-card live-chat-card"
          title={
            <>
              <LiveAgentLogo /> &nbsp; Live Agent
            </>
          }
        >
          <div className="live-chat-content">
            <Sidenav
              handleChat={handleAgentChat}
              getActivePatientNumber={getActivePatientNumber}
            />
            <div className="chat-container">
              <If condition={state.showChat}>
                <Then>
                  <Chat
                    agentChat
                    history={props.history}
                    Sound={Sound}
                    showChat={state.showChat}
                    handleShowDetails={handleShowDetails}
                    activeChatPatientNumber={state.activeChatPatientNumber}
                    handleAgentChat={handleAgentChat}
                  />
                </Then>

                <Else>
                  <div className="chat-welcome-message">
                    {NEXTGEN_EHR_WHITELABEL ? (
                      nextgenWelcomeIcon
                    ) : (
                      <img src={welcomeChatIcon} alt="" />
                    )}
                    <section className="content">
                      <p className="heading">Nothing to show</p>

                      <p className="message">
                        Please select active chats from the left panel and start
                        conversing.
                      </p>
                    </section>
                  </div>
                </Else>
              </If>
            </div>
          </div>
        </Card>
      </div>
      <MobileMenu component="liveAgent" />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  popupReducer: state.popupReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setPopup: (data) => dispatch(setPopup(data)),
    downloadPatientFiles: (object, cb) => {
      dispatch(downloadPatientFilesSagaAction(object, cb));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveAgent);
